<template>
  <div
    v-if="list.length > 0"
    class="counter-children"
  >
    <div
      v-for="item in list"
      :key="`counter-children-select-${item.id}`"
      class="counter-children__wrap --select"
    >
      <div
        class="counter-children__label"
        v-text="item.label"
      ></div>
      <!-- button minus -->
      <button
        v-if="item.value > 0"
        class="counter-children__button --minus"
        @click="setChildrenLength(-1, item)"
      >
        <img
          src="@/assets/icon/icon_minus_black.svg"
          alt=""
          class="counter-children__image"
        >
      </button>
      <div
        v-else
        class="counter-children__button --dummy"
      >
        <img
          src="@/assets/icon/icon_minus_gray.svg"
          alt=""
          class="counter-children__image"
        >
      </div>
      <!-- 人数表示 -->
      <div class="counter-children__display">
        {{ item.value }}人
      </div>
      <!-- button plus -->
      <button
        v-if="currentTotalLength < 10"
        class="counter-children__button --plus"
        @click="setChildrenLength(1, item)"
      >
        <img
          src="@/assets/icon/icon_plus_black.svg"
          alt=""
          class="counter-children__image"
        >
      </button>
      <div
        v-else
        class="counter-children__button --dummy"
      >
        <img
          src="@/assets/icon/icon_plus_gray.svg"
          alt=""
          class="counter-children__image"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    // 現在の合計人数
    currentTotalLength: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      temporaryList: [],       // 変更後のデータ
      remainingTotalLength: 0, // 残りの設定可能人数
    }
  },
  watch: {
    list() {
      this.onDeepCopyList()
    },
  },
  mounted() {
    this.onDeepCopyList()
  },
  methods: {
    onDeepCopyList() {
      if(this.list.length > 0) {
        this.temporaryList = JSON.parse(JSON.stringify(this.list))
      }
    },
    /**
     * 小学生の人数を設定する
     * studentListのvalueに代入する
     * @param {number} value 
     * @param {string} id 
     */
    setChildrenLength(value, item) {
      this.temporaryList = this.temporaryList.map(d => {
        return d.id === item.id
          ? { ...d, value: d.value + value }
          : d
      })
      this.$emit('changed', this.temporaryList)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.counter-children {
  display: flex;
  flex-wrap: wrap;
  row-gap: 1rem;
  width: 100%;

  @include sp {
    column-gap: .5rem;
  }

  &__label {
    font-size: .875rem;
    font-weight: normal;
    margin-bottom: .25rem;
    width: 100%;

    @include sp {
      max-width: 100%;
    }
  }

  &__button {
    align-items: center;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    height: 2.5rem;
    justify-content: center;
    width: 2rem;

    @include hover {
      opacity: .8;
    }

    &.--dummy {
      cursor: default;
    }
  }

  &__image {
    display: block;
    height: 1.5rem;
    width: 1.5rem;
  }

  &__display {
    align-items: center;
    border: 1px solid $cool-gray-3;
    border-radius: .25rem;
    display: flex;
    font-size: .875rem;
    height: 2.5rem;
    justify-content: center;
    max-width: 5rem;
    width: 100%;

    @include sp {
      max-width: 3.5rem;
    }
  }

  &__wrap {
    align-items: center;
    display: flex;

    &.--select {
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 10rem;
      padding: 0 .5rem;
      width: 50%;

      @include sp {
        justify-content: center;
        max-width: 100%;
        padding: 0;
        width: calc(50% - .25rem);
      }
    }
  }
}
</style>